export enum TextDirection {
  Auto = 'auto',
  LTR = 'ltr',
  RTL = 'rtl'
}
